import Vue from 'vue';
import VDateRange from 'vuetify-daterange-picker';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';

export default () => {
  Vue.use(VDateRange);
};
